export default "__VITE_ASSET__DqSWciZX__"